import { render, staticRenderFns } from "./EmployeePayslip.vue?vue&type=template&id=0570763e&scoped=true&"
import script from "./EmployeePayslip.vue?vue&type=script&lang=js&"
export * from "./EmployeePayslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570763e",
  null
  
)

export default component.exports